import { AuthorizationType } from '../../../components/authorizationHeader/authorizationHeader.types';

type GetAuthorizationHeaderTypeResponse =
  | Exclude<AuthorizationType, 'none'>
  | undefined;

/** Returns the authorization type of an authorization header. */
export const getAuthorizationHeaderType = (
  value?: string,
): GetAuthorizationHeaderTypeResponse => {
  if (!value) return undefined;

  const lowerCaseValue = value.toLowerCase();

  if (lowerCaseValue.startsWith('bearer ')) {
    return 'bearer';
  }

  if (lowerCaseValue.startsWith('basic ')) {
    return 'basic';
  }

  return 'custom';
};
